export const ADD_COLUMN = 'ADD_COLUMN';
export const REMOVE_COLUMN = 'REMOVE_COLUMN';
export const SET_INITIAL_COLUMNS = 'SET_INITIAL_COLUMNS';
export const SET_ALL_SUBMISSIONS = 'SET_ALL_SUBMISSIONS';
export const SET_TEST_ORGS_SUBS = 'SET_TEST_ORGS_SUBS';
export const SET_SUBMISSION_PER_PAGE = 'SET_SUBS_PER_PAGE';
export const SET_TABLE_FILTER = "SET_TABLE_FILTER";
